( function () {
	'use strict';

	function ClickOutside ( $document ) {
		function clickOutsideLink ( scope, element ) {
			var handler = function ( event ) {
				// dont apply change when right-click ( event.which )
				// apply condition if modal is hidden
				var  condition  = !element[ 0 ].contains( event.target ) && event.which !== 3 && !angular.element( '.modal' ).is( ':visible' );

				// apply condition if element is in modal
				if ( element.closest( '.modal-dialog' ).length ) {
					condition = !element[ 0 ].contains( event.target ) && event.which !== 3;
				}

				if ( condition ) {
					scope.$apply( function () {
						scope.clickOutside( {
							'$event' : event
						} );
					} );
				}
			};

			$document.on( 'click touchend', handler );

			scope.$on( '$destroy', function () {
				$document.off( 'click touchend', handler );
			} );
		}

		return {
			'restrict' : 'A',

			'scope' : {
				'clickOutside' : '&'
			},

			'link' : clickOutsideLink
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'clickOutside', ClickOutside );

	ClickOutside.$inject = [ '$document' ];
} )( );
